import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, CheckCircle2, XCircle, Loader2, RefreshCw } from "lucide-react";

export function PrintDiagnosticCard({ diagnostic, diagRunning, runDiagnostic }) {
  return (
    <Card className="border-l-4 border-l-gray-400" data-testid="diagnostic-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <AlertTriangle className="w-5 h-5 text-gray-500" /> Diagnostico de Impressao
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 pt-0">
        <p className="text-xs text-gray-500">Se nenhum metodo funciona, rode o diagnostico para verificar o que esta falhando.</p>
        <Button onClick={runDiagnostic} disabled={diagRunning} variant="outline" className="gap-2" data-testid="run-diagnostic-btn">
          {diagRunning ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
          RODAR DIAGNOSTICO
        </Button>
        {diagnostic && (
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-2 text-xs font-mono" data-testid="diagnostic-results">
            <div className="flex items-center gap-2">
              {diagnostic.certEndpoint.ok ? <CheckCircle2 className="w-4 h-4 text-emerald-500" /> : <XCircle className="w-4 h-4 text-red-500" />}
              <span>Certificado QZ: {diagnostic.certEndpoint.ok ? "OK" : `ERRO - ${diagnostic.certEndpoint.error || 'HTTP ' + diagnostic.certEndpoint.status}`}</span>
            </div>
            <div className="flex items-center gap-2">
              {diagnostic.signEndpoint.ok ? <CheckCircle2 className="w-4 h-4 text-emerald-500" /> : <XCircle className="w-4 h-4 text-red-500" />}
              <span>Assinatura digital: {diagnostic.signEndpoint.ok ? "OK" : `ERRO - ${diagnostic.signEndpoint.error || 'HTTP ' + diagnostic.signEndpoint.status}`}</span>
            </div>
            <div className="flex items-center gap-2">
              {diagnostic.qzModule ? <CheckCircle2 className="w-4 h-4 text-emerald-500" /> : <XCircle className="w-4 h-4 text-red-500" />}
              <span>Modulo QZ Tray: {diagnostic.qzModule ? `Carregado (v${diagnostic.qzVersion || '?'})` : "Nao carregado"}</span>
            </div>
            <div className="flex items-center gap-2">
              {diagnostic.qzWebsocketActive ? <CheckCircle2 className="w-4 h-4 text-emerald-500" /> : <XCircle className="w-4 h-4 text-red-500" />}
              <span>WebSocket QZ: {diagnostic.qzWebsocketActive ? "Conectado" : "Desconectado"}</span>
            </div>
            <div className="flex items-center gap-2">
              {diagnostic.webSerial ? <CheckCircle2 className="w-4 h-4 text-emerald-500" /> : <XCircle className="w-4 h-4 text-red-500" />}
              <span>Web Serial: {diagnostic.webSerial ? "Suportado" : "Nao suportado neste navegador"}</span>
            </div>
            <div className="flex items-center gap-2">
              {diagnostic.webUSB ? <CheckCircle2 className="w-4 h-4 text-emerald-500" /> : <XCircle className="w-4 h-4 text-red-500" />}
              <span>WebUSB: {diagnostic.webUSB ? "Suportado" : "Nao suportado neste navegador"}</span>
            </div>
            {diagnostic.backendDiagnostic && (
              <div className="border-t pt-2 mt-2 text-gray-500">
                Backend: cert={diagnostic.backendDiagnostic.cert_valid ? "valido" : "invalido"}, sign={diagnostic.backendDiagnostic.sign_works ? "OK" : "ERRO"}
              </div>
            )}
            <p className="text-[10px] text-gray-400 mt-2">API: {diagnostic.apiUrl} | {diagnostic.timestamp}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
